define('ordersDetailDocumentsView',[
  'module',
  'marionette',
  'underscore',
  'settings',
  'ordersDetailDocumentsOrderView',
  'ordersDetailDocumentsCustomerView',
  'template!ordersDetailDocumentsView'
], function (
  Module,
  Marionette,
  _,
  Settings,
  OrderView,
  CustomerView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-documents-view',

    regions: {
      orderDocumentsRegion: '.order-documents-region',
      customerDocumentsRegion: '.customer-documents-region'
    },

    ui: {
      customerDocuments: '.btn-edit-client'
    },

    onShow: function () {

      this.orderView = new OrderView({
        model: this.model.get('order'),
        customer: this.options.customer,
        documentsView: this
      });
      this.getRegion('orderDocumentsRegion').show(this.orderView);

      //------------

      if (Settings.configValue('order.attachments.showCustomerAttachments') === true) {
        this.customerView = new CustomerView({
          model: this.options.customer,
          order: this.model.get('order'),
          documentsView: this
        });
        this.getRegion('customerDocumentsRegion').show(this.customerView);
      } else {
        this.$el.find('.customer-documents').hide();
      }
    }
  });
});

